import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import TextImageAsideBlock from '@/blocks/TextImageAsideBlock';
import IntroText from '@/components/IntroText';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import ButtonLink from '@/ui/ButtonLink';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import Markdown from 'react-markdown';
import page from '@/graphql/queries/page';

export default function CareersPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.heroImage?.data?.attributes?.url ? (
        <BrandHeroBlock
          image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
          title={contentSection[0].heroTitle}
        />
      ) : null}
      <BreadcrumbsBlock items={[pages.home, pages.careers]} />
      <motion.section
        className="my-16 px-4"
        initial="hidden"
        transition={fadeInUp.transition}
        variants={fadeInUp}
        viewport={fadeInUp.viewport}
        whileInView="visible"
      >
        <div className="container-screen">
          <IntroText className="max-w-screen-lg">
            <Markdown>{contentSection[1]?.content || ''}</Markdown>
          </IntroText>
        </div>
      </motion.section>
      {contentSection[2]?.image?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[2].image.data.attributes.url)}
          imageDirection="left"
          title={
            <h2 className="text-3xl font-medium lg:text-4xl">
              {splitSentence(contentSection[2]?.title || '')[0]}
              <span className="text-primary-500">
                {splitSentence(contentSection[2]?.title || '')[1]}
              </span>
            </h2>
          }
        >
          <Markdown>{contentSection[2]?.text || ''}</Markdown>
          {contentSection[2]?.link?.url ? (
            <ButtonLink className="no-underline" color="primary" href={contentSection[2].link.url}>
              {contentSection[2]?.link?.text || ''}
            </ButtonLink>
          ) : null}
        </TextImageAsideBlock>
      ) : null}
      {contentSection[3]?.image?.data?.attributes?.url ? (
        <TextImageAsideBlock
          image={MEDIA_URL.concat(contentSection[3].image.data.attributes.url)}
          imageDirection="right"
          title={
            <h2 className="text-3xl font-medium lg:text-4xl">
              {splitSentence(contentSection[3]?.title || '')[0]}
              <span className="text-primary-500">
                {splitSentence(contentSection[3]?.title || '')[1]}
              </span>
            </h2>
          }
        >
          <Markdown>{contentSection[3]?.text || ''}</Markdown>
          {contentSection[3]?.link?.url ? (
            <ButtonLink className="no-underline" color="primary" href={contentSection[3].link.url}>
              {contentSection[3]?.link?.text || ''}
            </ButtonLink>
          ) : null}
        </TextImageAsideBlock>
      ) : null}
    </FullWidthLayout>
  );
}

const splitSentence = (sentence) => {
  return sentence.split('*');
};

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'careers' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
